import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ToggleInput from './ToggleInput'
import TextInput from './TextInput'

const CollectRSVPSection = ({ collectRSVP, signUpLink, setFieldValue }) => {
  const { t } = useTranslation(['eventManagement'])

  return (
    <React.Fragment>
      <div className="columns">
        <ToggleInput
          columnSize={12}
          name="collectRSVP"
          value={collectRSVP}
          label={t('eventManagement:common.collectRsvpsLabel')}
          tooltip={
            <>
              <p>{t('eventManagement:common.collectRsvpsTooltipLine1')}</p>
              <p>{t('eventManagement:common.collectRsvpsTooltipLine2')}</p>
              <p>{t('eventManagement:common.collectRsvpsTooltipLine3')}</p>
            </>
          }
          onToggle={setFieldValue}
        />
      </div>
      <div className="columns">
        {collectRSVP && (
          <TextInput
            columnSize={12}
            name="signUpLink"
            label=""
            placeholder={t('eventManagement:common.enterSignupLinkOrEmail')}
            helperText={t('eventManagement:common.collectRsvpsHelperText')}
            value={signUpLink}
            setFieldValue={setFieldValue}
            maxLength={255}
          />
        )}
      </div>
    </React.Fragment>
  )
}

CollectRSVPSection.propTypes = {
  collectRSVP: PropTypes.bool,
  signUpLink: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
}

export default CollectRSVPSection
